import type {Component} from 'grapesjs';
import type {CropData} from '@Panels/cropper-panel/cropper-panel.types';
import {EMAIL_MAKER_PROPS} from '@EmailMakerReact/email-maker-react.constants';

/** A crop equals the full image when every edge is within this tolerance. */
const WHOLE_IMAGE_CROP_TOLERANCE_PX = 1;

export function getStoredCropData(component: Component): CropData | undefined {
  const storedCropData = component.get(EMAIL_MAKER_PROPS.CROP_DATA) as Partial<CropData> | undefined;
  return storedCropData ? normalizeCropData(storedCropData) : undefined;
}

/** CropData rounding; the key order is serialized into saved templates and MUST be preserved. */
export function normalizeCropData(cropData: Partial<CropData>): CropData {
  return {
    x: Math.round(cropData.x ?? 0),
    y: Math.round(cropData.y ?? 0),
    width: Math.round(cropData.width ?? 0),
    height: Math.round(cropData.height ?? 0),
    imageWidth: Math.round(cropData.imageWidth ?? 0),
    imageHeight: Math.round(cropData.imageHeight ?? 0),
  };
}

export function doesCropCoverWholeImage(cropData: CropData): boolean {
  const deltaWidth = Math.abs(cropData.width - cropData.imageWidth);
  const deltaHeight = Math.abs(cropData.height - cropData.imageHeight);

  return (
    cropData.x <= WHOLE_IMAGE_CROP_TOLERANCE_PX &&
    cropData.y <= WHOLE_IMAGE_CROP_TOLERANCE_PX &&
    deltaWidth <= WHOLE_IMAGE_CROP_TOLERANCE_PX &&
    deltaHeight <= WHOLE_IMAGE_CROP_TOLERANCE_PX
  );
}
